import { render } from "./01_Main.vue?vue&type=template&id=621d6714&scoped=true"
import script from "./01_Main.vue?vue&type=script&lang=js"
export * from "./01_Main.vue?vue&type=script&lang=js"

import "./01_Main.vue?vue&type=style&index=0&id=621d6714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621d6714"]])

export default __exports__